import { useCallback, useState } from "react";
import { mdiDeleteOutline, mdiEyeOutline, mdiTrayArrowUp } from "@mdi/js";
import Icon from "@mdi/react";
import clsx from "clsx";

import ChunkUploadFile from "components/ChunkUploadFile";
import { UPLOAD_DOCUMENT_URLS } from "constants/routes";
import { UploadedFile } from "models/Component";
import { IJoinDocsItem } from "models/HaulPay";
import styles from "./style.module.scss";
import { showErrorMessage } from "../../../../../../../helpers/toastMessage";

interface IProps {
  data: IJoinDocsItem;
  factoring_id?: string;
  onDocumentUploaded?: (document: any) => void;
}

export default function UploadDocItem({
  data,
  factoring_id,
  onDocumentUploaded
}: Readonly<IProps>) {
  const [uploadedFile, setUploadedFile] = useState<UploadedFile>();
  const [previewUrl, setPreviewUrl] = useState<string>();

  const handleFileUpload = (file: UploadedFile) => {
    setUploadedFile(file);
    onDocumentUploaded && onDocumentUploaded(file);
  };

  const deleteFile = () => {
    setUploadedFile(undefined);
    onDocumentUploaded && onDocumentUploaded(undefined);
  };

  const previewAttachment = useCallback(() => {
    const newWindow = window.open(previewUrl, "_blank");
    if (newWindow) {
      newWindow.focus();
    } else {
      showErrorMessage("Failed to open the window. It might have been blocked by the browser.");
    }
  }, [previewUrl]);

  return (
    <li className={styles.uploadDocItemContainer}>
      <h4 className={styles.title}>{data.title}</h4>
      <span className="text-xs desktop:text-base">{data.content}</span>
      <div className={styles.buttonGroup}>
        <ChunkUploadFile
          label={uploadedFile ? "Replace Doc" : "Upload Doc"}
          prefixNode={<Icon path={mdiTrayArrowUp} className="flex-none size-5" />}
          className={clsx(
            styles.uploadButton,
            "!border-input",
            uploadedFile ? "!text-success" : "!text-primary"
          )}
          autoUpload
          urlCallback={
            UPLOAD_DOCUMENT_URLS({
              factoring_id: factoring_id
            }).FACTORING
          }
          getPreviewUrl={setPreviewUrl}
          onUploadFinished={(files: any) => {
            const factoringFile: UploadedFile = files.map((file: any) => ({
              name: file.name,
              size: file.fileSize,
              type: file.fileType,
              fileType: file.categories.split(","),
              url: ""
            }));
            handleFileUpload(factoringFile);
          }}
        />

        {uploadedFile && (
          <>
            <button type="button" onClick={previewAttachment} className={styles.iconButton}>
              <Icon path={mdiEyeOutline} />
            </button>

            <button type="button" className={styles.iconButton} onClick={deleteFile}>
              <Icon path={mdiDeleteOutline} />
            </button>
          </>
        )}
      </div>
    </li>
  );
}
